import { render, staticRenderFns } from "./UploadDiffItemImage.vue?vue&type=template&id=7ef97010&scoped=true"
import script from "./UploadDiffItemImage.vue?vue&type=script&lang=js"
export * from "./UploadDiffItemImage.vue?vue&type=script&lang=js"
import style0 from "./UploadDiffItemImage.vue?vue&type=style&index=0&id=7ef97010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef97010",
  null
  
)

export default component.exports